import Context from "../../../context/Context";
import * as three11Util from "../../../aiim/util/three11Util";

export function generate311Url(item) {
  const source = item && item.getSource();
  const searchResult = item && item.getSearchResult();
  const feature = searchResult && searchResult.feature;
  const indoorsConfig = Context.getInstance().aiim.datasets.indoorsConfig;
  let url = indoorsConfig.get311Url();
  if (typeof url === "string") url = url.trim();
  if (typeof url === "string" && url.length > 0 && source && feature) {
    if (url.indexOf("{") !== -1 && url.indexOf("}") !== -1) {
      return three11Util.generate311Url(url,source,feature);
    } else {
      return three11Util.generate311Url_v1(url,source,feature);
    }
  }
  return Promise.resolve();
}

export function getGeometryValues(source,feature) {
  return three11Util.getGeometryValues(source,feature);
}
